import { useContext } from 'react'
import { expandedSideNavContext } from '../contexts'

// An easy way to access whether the sidenav is expanded
// Returns a tuple of [ expandedSideNav, setExpandedSideNav ]
function useExpandedSideNav() {
  return useContext(expandedSideNavContext)
}

export default useExpandedSideNav
